export const DEVELOP = '1';
export const VERSION = `4.6.${DEVELOP}`;
export const RC = 0;
// ############################################################################
// #         Develop configuration                                            #
// ############################################################################
export const CLIENT_DEVELOP = '-LSq3Wx5Ps5UHQKxrSDE'; // Develop
// export const CLIENT_DEVELOP = '-LSI48DvVTTYpUMZRqzI'; // Nightly
export const PAY_URL_DEVELOP = 'https://rebus-v4-pay.herokuapp.com';
export const AI_URL_DEVELOP = 'https://rebus-v4-ai.herokuapp.com';
export const BACKEND_DEVELOP = 'https://rebus-v4-dev.herokuapp.com';
export const ZEUS_DEVELOP = 'https://rebus-zeus-dev.herokuapp.com';
export const LOG_LEVEL_DEVELOP = '';
export const PAYMENT_PROV_DEVELOP = 'fake';
export const GOOGLE_API_DEVELOP = 'AIzaSyC2scnthFYp6G_sZ3Qinui90T7kgW_evgk';
// export const GOOGLE_CLIENT_ID_DEVELOP = '709449322010-2po62cblsbut1hrql6752dlbmet7tg30.apps.googleusercontent.com'; // Develop
export const GOOGLE_CLIENT_ID_DEVELOP = '709449322010-9369nhffj2s3me9has95m4ousl9ej664.apps.googleusercontent.com'; // Nightly
export const FACEBOOK_CLIENT_ID_DEVELOP = '1912744835703731';
export const LINKEDIN_CLIENT_ID_DEVELOP = '1912744835703731';
export const FIREBASE_DEVELOP = {
  apiKey: "AIzaSyCb1iBrN5sJT_r-qN_us-9ArgOo5BtsEjE",
  authDomain: "rebus-v4.firebaseapp.com",
  databaseURL: "https://rebus-v4.firebaseio.com",
  projectId: "rebus-v4",
  storageBucket: "rebus-v4.appspot.com",
  messagingSenderId: "709449322010"
}
// ############################################################################
// #         Staging configuration                                            #
// ############################################################################
export const CLIENT_STAGING = '-LSHtPJh5XGn5U5mQKkd';
export const PAY_URL_STAGING = 'https://rebus-v4-pay.herokuapp.com';
export const AI_URL_STAGING = 'https://rebus-v4-ai.herokuapp.com';
export const BACKEND_STAGING = 'https://rebus-v4-dev.herokuapp.com';
export const ZEUS_STAGING = 'https://rebus-zeus-dev.herokuapp.com';
export const LOG_LEVEL_STAGING = '';
export const PAYMENT_PROV_STAGING = 'payu';
export const GOOGLE_API_STAGING = 'AIzaSyC2scnthFYp6G_sZ3Qinui90T7kgW_evgk';
export const GOOGLE_CLIENT_ID_STAGING = '709449322010-u3sia1nlcpdl3s13jh1torm6sg8j92fg.apps.googleusercontent.com';
export const FACEBOOK_CLIENT_ID_STAGING = '1912744835703731';
export const LINKEDIN_CLIENT_ID_STAGING = '1912744835703731';
export const FIREBASE_STAGING = {
  apiKey: "AIzaSyCb1iBrN5sJT_r-qN_us-9ArgOo5BtsEjE",
  authDomain: "rebus-v4.firebaseapp.com",
  databaseURL: "https://rebus-v4.firebaseio.com",
  projectId: "rebus-v4",
  storageBucket: "rebus-v4.appspot.com",
  messagingSenderId: "709449322010"
}
// ############################################################################
// #         Production configuration                                         #
// ############################################################################
export const CLIENT_PRODUCTION = '-LJnmOzZpxgtA7NsaRz7';
export const PAY_URL_PRODUCTION = 'https://rebus-v4-pay-prod.herokuapp.com';
export const AI_URL_PRODUCTION = 'https://rebus-v4-prod.appspot.com';
export const BACKEND_PRODUCTION = 'https://rebus-v4-prod.herokuapp.com';
export const ZEUS_PRODUCTION = 'https://rebus-zeus-dev.herokuapp.com';
export const LOG_LEVEL_PRODUCTION = '';
export const PAYMENT_PROV_PRODUCTION = 'payu';
export const GOOGLE_API_PRODUCTION = 'AIzaSyC2scnthFYp6G_sZ3Qinui90T7kgW_evgk';
export const GOOGLE_CLIENT_ID_PRODUCTION = '709449322010-2po62cblsbut1hrql6752dlbmet7tg30.apps.googleusercontent.com';
export const FACEBOOK_CLIENT_ID_PRODUCTION = '1604072763226893';
export const LINKEDIN_CLIENT_ID_PRODUCTION = '1604072763226893';
export const FIREBASE_PRODUCTION = {
  apiKey: "AIzaSyC2scnthFYp6G_sZ3Qinui90T7kgW_evgk",
  authDomain: "rebus-v4-prod.firebaseapp.com",
  databaseURL: "https://rebus-v4-prod.firebaseio.com",
  projectId: "rebus-v4-prod",
  storageBucket: "rebus-v4-prod.appspot.com",
  messagingSenderId: "519996567265"
}
// -------------------------------------------------------------------------------



// WEBPACK FOOTER //
// ./src/environments/global.ts